module.exports = __webpack_public_path__ + "static/media/modal-email-registration.b370eb87.svg";